import {
  DataRoomMemberStats,
  DataRoomDocumentsStats,
  DataRoom,
  DataRoomSearchData,
} from 'router/subrouters/DataRoom/models/DataRoom';
import httpClient from '../httpClient';
import { PaginatedData } from 'models/PaginatedData';
import { DataRoomMember } from '../../models/DataRoomMember';
import { Params } from 'react-router-dom';
import { FilePreview } from 'models/File';

function dataRoomLogout(dataRoomId: string) {
  return httpClient.post(`data-rooms/${dataRoomId}/logout`);
}

function getRoom(dataRoomId: string) {
  return httpClient.get<DataRoom>(`data-rooms/${dataRoomId}`);
}

function patchDataRoom(dataRoomId: string, data: Partial<DataRoom>) {
  return httpClient.patch<DataRoom>(`data-rooms/${dataRoomId}`, data);
}

function getMemberStats(dataRoomId: string) {
  return httpClient.get<DataRoomMemberStats>(
    `data-rooms/${dataRoomId}/by-members-dashboard`,
  );
}

function getMembers(dataRoomId: string, params?: Params) {
  return httpClient.get<PaginatedData<DataRoomMember>>(
    `data-rooms/${dataRoomId}/by-members`,
    { params },
  );
}

function getDocumentsStats(dataRoomId: string) {
  return httpClient.get<DataRoomDocumentsStats>(
    `data-room-node-reports/data-rooms/${dataRoomId}/by-nodes-dashboard`,
  );
}

function getExportedIndex(dataRoomId: string) {
  return httpClient.get<FilePreview>(`data-rooms/${dataRoomId}/export-index`);
}

function addQuestionSubject(dataRoomId: string, name: string) {
  return httpClient.post(`data-rooms/${dataRoomId}/question-subject/add`, {
    name,
  });
}

function editQuestionSubject(
  dataRoomId: string,
  newName: string,
  oldName: string,
) {
  return httpClient.post(`data-rooms/${dataRoomId}/question-subject/edit`, {
    newName,
    oldName,
  });
}

function removeQuestionSubject(dataRoomId: string, name: string) {
  return httpClient.post(`data-rooms/${dataRoomId}/question-subject/remove`, {
    name,
  });
}

function toggleQa(dataRoomId: string, isDisabledQA: boolean) {
  return httpClient.post(`data-rooms/${dataRoomId}/toggle-qa`, {
    isDisabledQA,
  });
}

function closeDataRoom(dataRoomId: string, isClosed: boolean) {
  return httpClient.post(`data-rooms/${dataRoomId}/close`, {
    isClosed,
  });
}

function disableDataRoom(dataRoomId: string, isDisabled: boolean) {
  return httpClient.post(`data-rooms/${dataRoomId}/disable`, {
    isDisabled,
  });
}

function searchDataRoom(dataRoomId: string, searchString: string) {
  return httpClient.get<DataRoomSearchData>(`data-rooms/${dataRoomId}/search`, {
    params: { searchString },
  });
}

function updateGlobalSecuritySettings(
  dataRoomId: string,
  data: Partial<DataRoom>,
  applyOnExistingFiles: boolean,
) {
  return httpClient.post<DataRoom>(
    `data-rooms/${dataRoomId}/global-security-settings`,
    { ...data, applyOnExistingFiles },
  );
}

function updateCompleteOnboarding(dataRoomId: string) {
  return httpClient.post<DataRoom>(
    `data-rooms/${dataRoomId}/complete-onboarding`,
  );
}

function getStorageCapacityUtilization(dataRoomId: string) {
  return httpClient.get<{ storageCapacityUtilization: number }>(
    `data-rooms/${dataRoomId}/storage-capacity-utilization`,
  );
}

export default {
  dataRoomLogout,
  getRoom,
  patchDataRoom,
  getMembers,
  getMemberStats,
  getDocumentsStats,
  getExportedIndex,
  addQuestionSubject,
  editQuestionSubject,
  removeQuestionSubject,
  toggleQa,
  closeDataRoom,
  disableDataRoom,
  searchDataRoom,
  updateGlobalSecuritySettings,
  updateCompleteOnboarding,
  getStorageCapacityUtilization,
};
